import { combineLatest, map } from 'rxjs';
import {
  featureOperations,
  Features,
  type FeatureContext,
} from '@ardoq/features';
import { featureContext$ } from 'streams/featureContext$';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { activeView$ } from 'streams/views/mainContent/activeView$';
import { isViewpointModeView } from 'views/environmentals/viewSettings/utils';
import type { ViewIds } from '@ardoq/api-types';

type IsPerspectivesAiButtonVisibleArgs = {
  featureContext: FeatureContext;
  isViewpointMode: boolean;
  mainViewId: ViewIds;
};

export const isPerspectivesAiButtonVisible = ({
  featureContext,
  isViewpointMode,
  mainViewId,
}: IsPerspectivesAiButtonVisibleArgs): boolean => {
  const hasAssistantFeature = featureOperations.hasFeature(
    featureContext,
    Features.AI_CHAT
  );

  return (
    hasAssistantFeature && isViewpointMode && isViewpointModeView(mainViewId)
  );
};

export const isPerspectivesAiButtonVisible$ = combineLatest([
  featureContext$,
  isViewpointMode$,
  activeView$,
]).pipe(
  map(([featureContext, { isViewpointMode }, { mainViewId }]) =>
    isPerspectivesAiButtonVisible({
      featureContext,
      isViewpointMode,
      mainViewId,
    })
  )
);
